import React, { useEffect, useRef } from "react";
import { IoMdClose } from "react-icons/io";

const VideoModal = ({
  link = "https://vimeo.com/347119375",
  video = "",
  show = false,
  onHide = () => {},
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      if (show) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [show]);

  return (
    <>
      <div
        className={`fixed top-0 left-0 right-0 bottom-0 bg-[#00000070] ${show ? "block z-[9999]" : "hidden z-[-999]"} flex justify-center items-center`}
      >
        <div
          className="fixed w-full h-full z-[100] top-0 right-0 left-0 bottom-0"
          onClick={onHide}
        />
        <div
          onClick={onHide}
          className="absolute z-[150] top-[20px] right-[20px]"
        >
          <IoMdClose
            style={{ color: "#fff", fontSize: 28, cursor: "pointer" }}
          />
        </div>
        <div className="flex items-center justify-center relative z-[150] w-[90vw] max-w-[800px] max-h-[80%]">
          {link.url ? (
            <iframe
              title={"hero-video"}
              src={link}
              width="100%"
              height="100%"
              allow={`${show ? "autoplay; fullscreen" : ""}`}
              // allowFullScreen
            />
          ) : (
            <video
              width="100%"
              height="100%"
              controls
              autoPlay={show}
              muted={!show}
              ref={videoRef}
              preload="none"
            >
              <source src={video?.url} type="video/mp4" />
            </video>
          )}
        </div>
      </div>
    </>
  );
};

export default VideoModal;
